<template>
    <div>
        <q-card style="background: #f8fcff">
            <q-bar class="bg-primary text-white">
                <q-icon name="mdi-bank" />
                <div>Bienes</div>
                <q-space />
                <q-btn dense flat icon="close" v-close-popup>
                    <q-tooltip>Close</q-tooltip>
                </q-btn>
            </q-bar>
            <q-card-section>
                <div class="row q-col-gutter-md">
                    <div class="col-12 col-md-3">
                        <q-input readonly dense class="color-input" outlined v-model="item.numero_emp" label="Número" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.unidad_negocio" label="Unidad Negocio" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.ui_estado" label="Año" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.cc_estado" label="Periodo" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.combinacion" label="Cuenta PREI" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.numero_acta" label="Descripción" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.categoria" label="Categoria" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.no_alta" label="Descripción de la categoria" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.id_activo" label="Número Nacional de Inventario" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.descripcion" label="Descripción del Bien" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.comple_desc" label="Caracteristicas del Bien" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.id_articulo" label="ID Artículo" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.descr_articulo" label="Descripción del Artículo" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.nom_fabricante" label="Marca" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.modelo" label="Modelo" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.id_serie" label="ID Serie" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.clase" label="Clase" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.fecha_ultmo_mov" label="Descripción de la clase" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.uni_oper" label="Unidad Operativa" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.no_movimiento"
                            label="Descripción de la Unidad Operativa" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.unidad_info" label="Unidad de la Información" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.tipo_resguardo" label="Validad UI" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.descr_unidad"
                            label="Descripción de la Unidad de Información" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.centro_costo" label="Centro Costo" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.descr_centro"
                            label="Descripción del Centro de Costos" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.sr" label="Seguro Ramo" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.num_usuarios" label="Descripción Seguro Ramo" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.costo" label="Inversión" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.depreciacion_acum"
                            label="Depreciasión Acumulada" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.fecha_adquisicion" label="Fecha de Adquisición" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.fecha_alta" label="Fecha de Alta" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.comentario_nni" label="Nota Recepción" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.contrato" label="Contrato IMSS" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.ubicacion" label="Ubicación" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.division" label="División" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.subdivision" label="Subdivisión" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.matricula" label="Matricula Usuario Responsable" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.nom_usuario" label="Nombre Usuario Responsable" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.matricula_rcab" label="Matricula RCAB" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly dense filled v-model="item.nombre_rcab" label="Nombre de RCAB" />
                    </div>



                    <div class="col-12 col-md-3">
                        <q-input readonly class="color-input" dense outlined v-model="item.nombre_emp"
                            label="Nombre del Bien" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly class="color-input" dense outlined v-model="item.descripcion_emp"
                            label="Descripción" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly class="color-input" dense outlined v-model="item.marca_emp" label="Marca" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly class="color-input" dense outlined v-model="item.serie_emp" label="Serie" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly class="color-input" dense outlined v-model="item.modelo_emp" label="Modelo" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly class="color-input" dense outlined v-model="item.est_conserv_emp"
                            label="Estado Conservación" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly class="color-input" dense outlined v-model="item.ubicacion_emp"
                            label="Ubicación" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly class="color-input" dense outlined v-model="item.usuario_emp"
                            label="Usuario" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly class="color-input" dense outlined v-model="item.resultado_emp"
                            label="Resultado Toma Fisica" />
                    </div>
                    <div class="col-12 col-md-3">
                        <q-input readonly class="color-input" dense outlined v-model="item.obeservaciones_emp"
                            label="Observaciones" />
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>
<script>
import { format } from 'date-fns';
import { date, QSpinnerFacebook } from 'quasar'
import moment from 'moment';
import axios from "axios";
import * as XLSX from 'xlsx';
export default {
    components: {
    },
    data() {
        return {
        }
    },
    computed: {
        usuarioStore() {
            return this.$store.state.usuario
        },
        item() {
            return this.$store.state.bienStore
        },
    },
    created() {
    },
    methods: {

    }
}
</script>
<style>
.color-input {
    background-color: #ddffe4;
}
</style>
